import { useEffect, useRef } from 'react'

const Watermark = ({ content }: { content: string }) => {
  const watermarkRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    // 减小字体大小
    const fontSize = 12
    const text = content
    canvas.width = 200
    canvas.height = 150

    ctx.font = `${fontSize}px Microsoft Yahei`
    ctx.fillStyle = 'rgba(0, 0, 0, 0.15)'
    ctx.textAlign = 'left'
    ctx.textBaseline = 'middle'
    ctx.rotate((-20 * Math.PI) / 180)
    ctx.fillText(text, canvas.width / 10, canvas.height / 2)

    const base64Url = canvas.toDataURL()
    const watermarkElement = watermarkRef.current
    if (watermarkElement) {
      watermarkElement.style.backgroundImage = `url(${base64Url})`
      watermarkElement.style.pointerEvents = 'none'
      watermarkElement.style.position = 'fixed'
      watermarkElement.style.top = '0'
      watermarkElement.style.left = '0'
      watermarkElement.style.width = '100%'
      watermarkElement.style.height = '100%'
      watermarkElement.style.zIndex = '9999'
    }
  }, [content])

  return <div ref={watermarkRef} />
}
export default Watermark
